(function () {
  'use strict';

  angular.module('mean.admin').controller('UsersController', ['$scope', '$timeout', 'Global', 'Menus', 'Users', 'MeanUser', 'tradeCodeService', '$filter', 'Trades', 'Builders', 'Subtasks', 'Bids', 'Contacts', 'Holidays', 'Extras', 'Requests', 'Materials', 'Equipments', 'Projects', 'ProjectBids', 'ProjectTasks', 'ProjectMaterials', 'ProjectEquipments', 'ProjectJobs', 'HiddenItems', 'ProjectContacts', 'ProjectHours', 'BidMaterialsSaves', 'toaster', 'CombinationService', '$http',
    function ($scope, $timeout, Global, Menus, Users, MeanUser, tradeCodeService, $filter, Trades, Builders, Subtasks, Bids, Contacts, Holidays, Extras, Requests, Materials, Equipments, Projects, ProjectBids, ProjectTasks, ProjectMaterials, ProjectEquipments, ProjectJobs, HiddenItems, ProjectContacts, ProjectHours, BidMaterialsSaves, toaster, CombinationService, $http) {
      $scope.global = Global;
      $scope.package = {
        name: 'admin'
      };
      $scope.example14model = [];
      $scope.example14data = [];
      $scope.example14settings = {
        buttonClasses: 'form-control',
        externalIdProp: '',
        enableSearch: false,
        smartButtonMaxItems: 1,
        scrollableHeight: '150px',
        scrollable: true
      };
      $scope.example5customTexts = {
        buttonDefaultText: 'Select Combination'
      };
      $scope.sortType = ['username'];
      $scope.sortReverse = false;

      $scope.userSchema = [{
        title: 'Email',
        schemaKey: 'email',
        type: 'text',
        inTable: true
      }, {
        title: 'Name',
        schemaKey: 'name',
        type: 'text',
        inTable: true
      }, {
        title: 'Employee ID',
        schemaKey: 'username',
        type: 'text',
        inTable: true
      }, {
        title: 'Roles',
        schemaKey: 'roles',
        type: 'select',
        options: [{
          name: 'System Admin',
          code: 'admin'
        }, {
          name: 'Builder Admin',
          code: 'builder_admin'
        }, {
          name: 'Builder',
          code: 'builder'
        }, {
          name: 'Purchasing Agent',
          code: 'purchasing_agent'
        }, {
          name: 'Project Manager',
          code: 'project_manager'
        }, {
          name: 'Trade Admin',
          code: 'tm_admin'
        }, {
          name: 'Trade Office',
          code: 'tm_office'
        }, {
          name: 'Trade Manager',
          code: 'tm'
        }, {
          name: 'Foreman',
          code: 'foreman'
        }, {
          name: 'Tradesman',
          code: 'tradesman'
        }],
        inTable: true
      }, {
        title: 'Password',
        schemaKey: 'password',
        type: 'password',
        inTable: false
      }, {
        title: 'Trade',
        schemaKey: 'trade',
        type: 'select',
        options: tradeCodeService.getArrayStrings(),
        inTable: true
      }, {
        title: 'Company Code',
        schemaKey: 'contractor_code',
        type: 'text',
        inTable: true
      }, {
        title: 'Pay Rate',
        schemaKey: 'pay_rate',
        type: 'pay',
        inTable: false
      }, {
        title: 'Phone',
        schemaKey: 'phone',
        type: 'phone',
        inTable: true
      }, {
        title: 'Active',
        schemaKey: 'active',
        type: 'boolean',
        inTable: true
      }, {
        title: 'Subscriber',
        schemaKey: 'subscriber',
        type: 'boolean',
        inTable: true
      }];

      $scope.user = {};

      $scope.trade = {
        options: tradeCodeService.getArray()
      }

      $scope.trade.options.push({
        name: 'System',
        value: 100
      });

      $scope.init = function () {
        $scope.getUsersList();
        $scope.showServiceUpdateButton = true;

        CombinationService.query({}, function (combination) {
          if (combination.length) {
            $scope.example14model = [{
              id: combination[0]._id,
              label: combination[0].projectType + ' (' + combination[0].geoLocation + ')',
              projectType: combination[0].projectType,
              type: combination[0].projectType,
              location: combination[0].geoLocation,
              geoLocation: combination[0].geoLocation,
              isCustom: combination[0].isCustom || false,
              userId: combination[0].userId || ''
            }];
          }
          combination.forEach(item => {
            if(item.projectType == 'Service' && item.isCustom == false) {
              $scope.showServiceUpdateButton = false;
            }
            $scope.example14data.push({
              id: item._id,
              label: item.projectType + ' (' + item.geoLocation + ')',
              projectType: item.projectTyp,
              type: item.projectType,
              geoLocation: item.geoLocation,
              location: item.geoLocation,
              isCustom: item.isCustom || false,
              userId: item.userId || ''
            });
          })
        });
      };

      $scope.addProjectServices = function() {
        console.log($scope);
        $http.get('/api/admin/addservice', {
          'param': 'testing'
        })
        .success(function(success) {
          console.log('in the success callback');
          console.log(success);
          $scope.showServiceUpdateButton = false;
        })
        .error(function(error) {
          console.log('in the error callback');
          console.log(error);
        });
      };

      $scope.getUsersList = () => {
        Users.query({ 'type': 'SystemUsersOnly' }, function (users) {
          $scope.users = users.map(e => {
            e['comb'] = e.combination.length ? e.combination.map(el => el.projectType || el.type + ' (' + el.location || el.geoLocation + ')').join(' ,') : 'NA'
            console.log(e['comb'], '<----')
            e['isEditable'] = false;
            return e;
          });
          console.log($scope.users)
        });
      }

      $scope.saveCombination = (user, index) => {
        console.log(user)
        user.isEditable = false;
        user.comb = '';
        user.$update();
        $timeout(function () {
          $scope.getUsersList();
        }, 0)
      };

      $scope.selectionCombination = function () {
        //console.log($scope.example14model);
      };
      $scope.add = function () {
        if (!$scope.users) $scope.users = [];
        $scope.user.trade = [];
        $scope.user.roles = [];

        if ($scope.user.tradeOption.name !== 'System') {
          $scope.user.trade.push($scope.user.tradeOption.name);

          var trade_code = $scope.user.tradeOption.value;

          if (trade_code == '00') {
            $scope.user.roles.push('builder_admin');
          } else {
            $scope.user.roles.push('tm_admin');
          }

          //we need to build the new user id #
          //first lets get a listing of all users in the
          //same trade and order it by company code
          var trade_users = $filter('filter')($scope.users, { 'trade': $scope.user.trade[0] }, true);
          trade_users = $filter('orderBy')(trade_users, 'contractor_code');

          //now parse the code and add one
          var company_code = 1;
          if (trade_users.length > 0) {
            company_code = parseInt(trade_users[trade_users.length - 1].contractor_code, 10);
            company_code++;
            if (company_code > 999) {
              alert('ran out of contractor codes!!!')
              return;
            }
          }

          $scope.user.contractor_code = ('000' + company_code).slice(-3);

          $scope.user.username = trade_code + $scope.user.contractor_code + '0000';

          if ($scope.user.username.length !== 9) {
            alert('username is required to be 9 digits in length');
            return;
          }

          var inlist = $filter('filter')($scope.users, { 'username': $scope.user.username }, true);

          if (inlist.length !== 0) {
            alert('The entered usrname is already in the list.');
            return;
          }

          var admin_roles = ['builder_admin', 'tm_admin', 'admin'];

          var id_check = $scope.user.username.split('', 9);

          if ((id_check[0] + id_check[1]) != tradeCodeService.getCode($scope.user.trade[0])) {
            alert('First two digits of the username do not match the selected trade.');
            return;
          }

          if ((id_check[2] + id_check[3] + id_check[4]) != $scope.user.contractor_code) {
            alert('The 3 digit company code in the username does not match the entered Company Code');
            return;
          }

          if ((id_check[5] + id_check[6] + id_check[7] + id_check[8]) != 0) {
            alert('The last for digits of the username should be all zeros');
            return;
          } else {
            if (admin_roles.indexOf($scope.user.roles[0]) === -1) {
              alert('You are creating an admin user but the role is not admin level.');
              return;
            }
          }
        } else {
          var system_users = $filter('filter')($scope.users, { 'contractor_code': '000' }, true);
          system_users = $filter('orderBy')(system_users, 'username');

          var new_username = 1;
          if (system_users.length > 0) {
            new_username = parseInt(system_users[system_users.length - 1].username, 10);
            new_username++;
            if (new_username > 9999) {
              alert('ran out of system user slots!!!')
              return;
            }
          }

          $scope.user.username = ('000000000' + new_username).slice(-9);
          $scope.user.trade = 'System';
          $scope.user.contractor_code = '000';
          $scope.user.roles = 'admin';
        }

        console.log('adding user %s with role %s and trade %s',
          $scope.user.name, $scope.user.roles[0], $scope.user.trade);

        var user = new Users({
          email: $scope.user.email,
          name: $scope.user.name,
          username: $scope.user.username,
          password: $scope.user.password,
          confirmPassword: $scope.user.password,
          roles: $scope.user.roles,
          trade: $scope.user.trade,
          contractor_code: $scope.user.contractor_code,
          pay_rate: $scope.user.pay_rate,
          phone: $scope.user.phone,
          active: true,
          combination: $scope.example14model
          // ssn: $scope.user.ssn,
          // avatar: $scope.user.avatar
        });

        user.$save(function (response) {
          if (response.trade[0] === 'Builder') {
            //create Builders record
            var record = new Builders({
              'builder': response._id,
              'company_code': response.contractor_code
            });

            record.$save();
          } else if (response.trade[0] === 'System') {
            //no op...yet
          } else {
            //create Trades record
            Subtasks.query({
              'subtask_trade': tradeCodeService.getCode($scope.user.trade[0])
            },
              function (subtasks) {

                _.each(subtasks, function (subtask) {
                  subtask.code = subtask.subtask_code;
                  subtask.name = subtask.subtask_name
                  subtask.subtask_id = subtask._id;
                  subtask.task = subtask.subtask;
                  subtask.trade = subtask.subtask_trade;
                  subtask.unit = subtask.unit.unit;
                });

                var trade = new Trades({
                  'trade': response.trade[0],
                  'main_account_id': response._id,
                  'subtasks': subtasks,
                  'company_code': response.contractor_code
                });

                trade.$save();
              });
          }

          $scope.users.push(response);
        }, function (err) {
          alert('There was a problem with adding the user');
          console.log(err);

          if (angular.isArray(err.data)) {
            err.data.forEach(function (obj) {
              alert(obj.msg);
            });
          } else {
            alert('Make sure the email is not in the system already');
            alert('System message - ' + err.data);
          }
        });

        //user.firstName = user.lastName = user.email = user.password = user.role = '';

        $scope.user.name = '';
        $scope.user.email = '';
        $scope.user.password = '';
        $scope.user.phone = '';
        $scope.user.tradeOption = '';
        // $scope.user.ssn = '';
        // $scope.user.avatar = '';
      };

      $scope.remove = function (user) {
        for (var i in $scope.users) {
          if ($scope.users[i] === user) {
            $scope.users.splice(i, 1);
          }
        }

        user.$remove();
      };

      $scope.resetPassword = function (user) {
        $scope.user_to_change = user;
      };

      $scope.acceptNewPassword = function () {
        $scope.user_to_change.password =
          $scope.user_to_change.confirmPassword = this.new_user_password;

        MeanUser.resetForUser($scope.user_to_change);
      };

      $scope.update = function (user, userField) {
        console.log('we are now in the update function!!!!!!!!!!!!');
        if (angular.isArray(user.roles)) {
          user.roles = user.roles[0].code;
        } else {
          user.roles = user.roles.code;
        }
        if (userField && userField === 'roles' && user.roles.indexOf('admin') === -1) {
          //if (confirm('Are you sure you want to remove "admin" role?')) {
          user.$update();
          //} else {
          //    user.roles = user.tmpRoles;
          //}
        } else
          user.$update();
      };

      $scope.beforeSelect = function (userField, user) {
        if (userField === 'roles') {
          user.tmpRoles = user.roles;
        }
      };

      $scope.resetAccount = function () {
        //remove all data associated with $scope.user_to_change
        Users.query({
          'trade': $scope.user_to_change.trade[0],
          'contractor_code': $scope.user_to_change.contractor_code
        }, function (users) {
          users.forEach(function (user) {
            Contacts.query({ 'user': user._id }, function (contacts) {
              contacts.forEach(function (contact) {
                contact.$delete();
              });
            });

            var array = user.username.split('', 9);
            var code = array[5] + array[6] + array[7] + array[8];

            if (code !== '0000') {
              user.$delete();
            }
          });
        });

        Holidays.query({ 'main_account_id': $scope.user_to_change._id }, function (holidays) {
          holidays.forEach(function (holiday) {
            holiday.$delete();
          });
        });

        // Contacts.query({'user': $scope.user_to_change._id}, function(contacts) {
        //   contacts.forEach(function(contact) {
        //     contact.$delete();
        //   });
        // });

        Requests.query({ 'requestor': $scope.user_to_change._id }, function (contacts) {
          contacts.forEach(function (contact) {
            contact.$delete();
          });
        });

        Requests.query({ 'requestee': $scope.user_to_change._id }, function (contacts) {
          contacts.forEach(function (contact) {
            contact.$delete();
          });
        });

        if ($scope.user_to_change.trade[0] === 'Builder') {
          Builders.query({ 'builder': $scope.user_to_change._id }, function (builders) {
            if (builders.length !== 1) {
              toaster.pop('warning', 'Builder Record Error',
                'There is no database entry for this builder...creating...');
              var record = new Builders({
                'builder': $scope.user_to_change._id,
                'company_code': $scope.user_to_change.contractor_code
              });

              record.$save(function (success) {
                toaster.pop('success', 'Builder Created');
              }, function (error) {
                toaster.pop('error', 'Builder Create Error', error);
                return;
              });
            } else {
              Bids.query({ 'builder_id': builders[0]._id }, function (bids) {
                bids.forEach(function (bid) {
                  console.log(bid.bid_name)
                });
              });

              builders[0].name = '';
              builders[0].address_one = '';
              builders[0].address_two = '';
              builders[0].city = '';
              builders[0].state = '';
              builders[0].zip = '';
              builders[0].phone = '';
              builders[0].email = '';

              builders[0].$update();
            }
          });
        } else {
          Trades.query({ 'main_account_id': $scope.user_to_change._id }, function (trades) {
            if (trades.length !== 1) {
              toaster.pop('warning', 'Trade Record Error',
                'There is no database entry for this trade...creating...');
              Subtasks.query({
                'subtask_trade': tradeCodeService.getCode($scope.user_to_change.trade[0])
              },
                function (subtasks) {

                  _.each(subtasks, function (subtask) {
                    subtask.code = subtask.subtask_code;
                    subtask.name = subtask.subtask_name
                    subtask.subtask_id = subtask._id;
                    subtask.task = subtask.subtask;
                    subtask.trade = subtask.subtask_trade;
                    subtask.unit = subtask.unit.unit;
                  });

                  var trade = new Trades({
                    'trade': $scope.user_to_change.trade[0],
                    'main_account_id': $scope.user_to_change._id,
                    'subtasks': subtasks,
                    'company_code': $scope.user_to_change.contractor_code
                  });

                  record.$save(function (success) {
                    toaster.pop('success', 'Trade Created');
                  }, function (error) {
                    toaster.pop('error', 'Trade Create Error', error);
                    return;
                  });
                });
            } else {
              Bids.query({ 'trade_id': trades[0]._id }, function (bids) {
                bids.forEach(function (bid) {
                  bid.$delete();
                });
              });

              BidMaterialsSaves.query({ 'user': $scope.user_to_change._id }, function (items) {
                items.forEach(function (item) {
                  item.$delete();
                });
              });

              Extras.query({ 'trade_id': trades[0]._id }, function (extras) {
                extras.forEach(function (extra) {
                  extra.$delete();
                });
              });

              Materials.query({
                'type': 'DeleteByTradeId',
                'trade_account': trades[0]._id,
                'userId': $scope.user_to_change._id
              }, function (materials) {
                console.log('Materials removed');
              });

              Equipments.query({
                'type': 'DeleteByTradeId',
                'trade_account': trades[0]._id
              }, function (materials) {
                console.log('Equipments removed');
              });

              HiddenItems.query({
                'trade_code': tradeCodeService.getCode($scope.user_to_change.trade[0]),
                'company_code': $scope.user_to_change.contractor_code
              }, function (items) {
                items.forEach(function (item) {
                  item.$delete();
                });
              });

              trades[0].name = '';
              trades[0].address_one = '';
              trades[0].address_two = '';
              trades[0].city = '';
              trades[0].state = '';
              trades[0].zip = '';
              trades[0].phone = '';
              trades[0].email = '';

              trades[0].$update();
            }
          });
        }

        ProjectJobs.query({
          'trade_code': tradeCodeService.getCode($scope.user_to_change.trade[0]),
          'company_code': $scope.user_to_change.contractor_code
        }, function (jobs) {
          jobs.forEach(function (job) {
            job.$delete();
          });
        });

        Projects.query({
          'trade_code': tradeCodeService.getCode($scope.user_to_change.trade[0]),
          'company_code': $scope.user_to_change.contractor_code
        }, function (projects) {

          projects.forEach(function (project) {
            ProjectBids.query({
              'type': 'RemoveAllByProjectId',
              'project_id': project._id
            }, function (bids) {
              console.log('projectBids removed');
            });

            project.lots.forEach(function (lot) {
              ProjectTasks.query({
                'type': 'DeleteByIdLotPhase',
                'project_id': project._id,
                'lot': lot.number,
                'phase': lot.phase
              }, function (bids) {
                console.log('projectTasks removed');
              });
            });

            ProjectMaterials.query({ 'project_id': project._id }, function (reports) {
              reports.forEach(function (report) {
                report.$delete();
              });
            });

            ProjectEquipments.query({ 'project_id': project._id }, function (reports) {
              reports.forEach(function (report) {
                report.$delete();
              });
            });

            ProjectContacts.query({ 'project_id': project._id }, function (contacts) {
              contacts.forEach(function (contact) {
                contact.$delete();
              });
            });

            ProjectHours.query({
              'type': 'RemoveAllByProjectId',
              'project_id': project._id
            }, function (hours) {
              console.log('ProjectHours removed');
            });

            project.$delete();
          });
        });
      };
    }
  ]);
})();



// WEBPACK FOOTER //
// ./packages/custom/admin/public/controllers/users.js